import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const clients = [
  { name: "Biotek", logo: "/images/biotek.jpg" },
  { name: "Vero", logo: "/images/vero.jpg" },
  { name: "Energo Sistem", logo: "/images/energosistem.jpg" },
  { name: "Mona", logo: "/images/mona.jpg" },
  { name: "Olympus", logo: "/images/olympus.png" },
  { name: "Spektartermo", logo: "/images/sprektartermo.jpg", isSpecial: true },
  { name: "Atlantik", logo: "/images/atlantik.jpg" },
  { name: "BMW", logo: "/images/bmw.jpg" },
];

const moreClients = [
  { name: "abcbrother", logo: "/images/abcbrother.png" },
  { name: "Baumit", logo: "/images/baumit.png" },
  { name: "Bitem", logo: "/images/bitem-.png" },
  { name: "Wurth", logo: "/images/wurth.png" },
  { name: "Pope", logo: "/images/pope.png" },
  { name: "propoint", logo: "/images/propoint.png" },
  { name: "swislion", logo: "/images/swislion.png" },
  { name: "solid", logo: "/images/solid.png" },
  { name: "tehnokomerc", logo: "/images/tehnokomerc.png" },
  { name: "tinex", logo: "/images/tinex.png" },
  { name: "cineplex", logo: "/images/cineplex.png" },
  { name: "belupo", logo: "/images/belupo.png" },
  { name: "bimek", logo: "/images/bimek.png" },
  { name: "jumbo", logo: "/images/jumbo.png" },
  { name: "linkmedia", logo: "/images/linkmedia.png" },
  { name: "allelectric", logo: "/images/allelectric.png" },
  { name: "porcelana", logo: "/images/porcelana.png" },
  { name: "reforma", logo: "/images/reforma.png" },
  { name: "hempromak", logo: "/images/hempromak.png" },
  { name: "SATE", logo: "/images/sate.png" },
  { name: "telelink", logo: "/images/telelink.png" },
  { name: "carso", logo: "/images/carso.png" },
  { name: "merkur", logo: "/images/merkur.png" },
  { name: "marriott", logo: "/images/marriott.png" },
  
];

const Clients = () => {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  // Function to check if the client is one of the special ones
  const isSpecialClient = (name) => {
    const specialClients = [
      "abcbrother", "Pope", "tinex", "SATE", "reforma", "carso","hempromak", "belupo", "Wurth", "telelink", "bimek", "jumbo", "linkmedia", "allelectric"
    ];
    return specialClients.includes(name);
  };

  return (
    <section id="clients" className="px-5 max-w-[1290px] w-full mx-auto mt-32">
      <div>
        <p className="font-bold text-[16px] leading-[20.8px] text-[#4F4F4F]">
          {t("clients.clients")}
        </p>
        <div className="flex flex-col lg:w-[40%]">
          <h2 className="text-[27.65px] leading-[33.18px] font-extrabold text-[#111111] mb-4 mt-10">
            {t("clients.title")}
          </h2>
          <p className="text-[#3D3D3D] mb-6 text-[16px] leading-[20.8px] font-normal">
            {t("clients.description")}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 mt-10">
        {clients.map((client, index) => (
          <div
            key={index}
            className="bg-[#FEEED6] flex items-center justify-center p-10 rounded-[12px]"
          >
            <img
              src={client.logo}
              alt={client.name}
              className={`max-h-[80px] ${
                client.isSpecial ? "filter grayscale" : "filter grayscale"
              } transition-all duration-300 ease-in-out`}
              style={{
                transform: client.isSpecial ? "scale(1)" : "scale(1.5)",
              }}
              loading="lazy"
              onError={(e) => {
                console.error(`Failed to load image: ${client.logo}`, e);
              }}
            />
          </div>
        ))}
        {showMore &&
          moreClients.map((client, index) => (
            <div
              key={index}
              className="bg-[#FEEED6] flex items-center justify-center p-10 rounded-[12px]"
            >
              <img
                src={client.logo}
                alt={client.name}
                className="max-h-[80px] filter grayscale transition-all duration-300 ease-in-out"
                style={{
                  transform: isSpecialClient(client.name) ? "scale(2.7)" : "scale(1.2)",
                  maxWidth: '100%',
                  height: 'auto',
                  objectFit: 'contain'
                }}
                loading="lazy"
                onError={(e) => {
                  console.error(`Failed to load image: ${client.logo}`, e);
                }}
              />
            </div>
          ))}
      </div>

      <button
        onClick={toggleShowMore}
        className="mt-8 px-6 py-3 bg-[#FEEED6] text-[#F7983F] font-bold rounded-[12px] hover:bg-[#F7983F] hover:text-white transition-all duration-300 ease-in-out"
      >
        {showMore ? t("clients.viewLess") : t("clients.viewMore")}
      </button>

      <span className="w-full block h-[1px] bg-[#DCDCDC] mt-32 mb-20"></span>
    </section>
  );
};

export default Clients;
